import * as R from "ramda";
import { Button, message, Popover } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import React, { useEffect, useMemo, useState } from "react";

import {
  QrcodeAsImage,
  fetchPreviewInfo,
  fetchGalleryByOrderId,
} from "@/components/Common/GalleryPreview";

export const ViewMobileClip = (props) => {
  const orderId = R.pathOr("", ["match", "params", "orderid"], props) * 1;
  const [gallery, setGallery] = useState({});
  
  useEffect(() => {
    fetchGalleryByOrderId(orderId, R.T).then((detail) => {
      setGallery(detail);
    });
  }, [orderId]);

  const url = useMemo(() => {
    const url_labeling = R.pathOr("", ["url_labeling"], gallery);
    return `http://consumer.jimage.cn/mobile/videoClip/${url_labeling}`;
  }, [gallery]);
  return (
    <Popover
      content={
        <a href={url} target="_blank" title="点击在新窗口打开">
          <QrcodeAsImage url={url} />
        </a>
      }
      placement="bottom"
    >
      <CopyToClipboard text={url}>
        <Button
          icon="copy"
          onClick={() => {
            message.success("复制成功");
          }}
        >
          移动端智能剪辑
        </Button>
      </CopyToClipboard>
    </Popover>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/view-mobile-clip.js